import React, { useState, useEffect } from "react";
export function TopFarm() {
  const [show, setShow] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setShow(!show);
    }, 4000);
  }, [show]);
  return (
    <>
      {show && (
        <div className="Earn_p_i_bottom_switch_container">
          <div className="Earn_p_i_h2_switch">
            <h2>
              <span>Top</span> Farms
            </h2>
            <svg
              className="switch sc-6457768a-0 bQnrJn"
              viewBox="0 0 24 25"
              height="24px"
              width="24px"
              color="textSubtle"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M16 17.01V11C16 10.45 15.55 10 15 10C14.45 10 14 10.45 14 11V17.01H12.21C11.76 17.01 11.54 17.55 11.86 17.86L14.65 20.64C14.85 20.83 15.16 20.83 15.36 20.64L18.15 17.86C18.47 17.55 18.24 17.01 17.8 17.01H16ZM8.65003 3.35002L5.86003 6.14002C5.54003 6.45002 5.76003 6.99002 6.21003 6.99002H8.00003V13C8.00003 13.55 8.45003 14 9.00003 14C9.55003 14 10 13.55 10 13V6.99002H11.79C12.24 6.99002 12.46 6.45002 12.14 6.14002L9.35003 3.35002C9.16003 3.16002 8.84003 3.16002 8.65003 3.35002Z"></path>
            </svg>
          </div>
          <div className="Earn_p_i_lower_big_container">
            <div className="Earn_p_i_container1">
              <div className="Earn_p_i_text1">OLE-BUSD LP</div>
              <div className="Earn_p_i_text2">173.957%</div>
              <div className="Earn_p_i_text3">APR</div>
            </div>
            <div className="Earn_p_i_container2">
              <div className="Earn_p_i_text1">TRIVIA-BNB LP</div>
              <div className="Earn_p_i_text2">141.115%</div>
              <div className="Earn_p_i_text3">APR</div>
            </div>
            <div className="Earn_p_i_container3">
              <div className="Earn_p_i_text1">SDAO-BUSD LP</div>
              <div className="Earn_p_i_text2">96.231%</div>
              <div className="Earn_p_i_text3">APR</div>
            </div>
            <div className="Earn_p_i_container4">
              <div className="Earn_p_i_text1">RPG-BUSD LP</div>
              <div className="Earn_p_i_text2">88.912%</div>
              <div className="Earn_p_i_text3">APR</div>
            </div>
            <div className="Earn_p_i_container5">
              <div className="Earn_p_i_text1">DUET-CAKE LP</div>
              <div className="Earn_p_i_text2">87.348%</div>
              <div className="Earn_p_i_text3">APR</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
